<template>
	<div class="chat flex">
		<div class="chat-list">
			<ul>
				<li v-for="(item, i) in chatList" :key="i" class="flex" :class="{'z-crt': currentChat == item.id}" @click="currentChat = item.id">
					<div class="icon flex-center">
						<img :src="item.icon">
					</div>
					<div class="flex-grow flex-column" style="gap: 4px;">
						<div class="flex-between-center">
							<p class="name ellipsis">{{item.name || '未设置昵称'}}</p>
							<span class="date">{{item.date}}</span>
						</div>
						<p v-if="item.describe" class="describe ellipsis">{{item.describe}}</p>
						<div class="flex-between-center">
							<p class="message flex-grow ellipsis">{{item.message}}</p>
							<ins v-if="item.unread && currentChat != item.id" class="unread">{{item.unread}}</ins>
						</div>
					</div>
				</li>
			</ul>
		</div>
		<div class="chat-room flex-column flex-grow">
			<c-empty v-if="!currentChatData"></c-empty>
			<template v-else>
				<div class="room-head flex-center">
					<div class="icon flex-center">
						<img :src="currentChatData.icon">
					</div>
					<div class="flex-grow">
						<p class="name">{{currentChatData.name || '未设置昵称'}}</p>
					</div>
					<div class="member flex-center" @click.stop="memberState = true">
						<div v-for="(item, i) in memberList" :key="i" class="icon flex-center">
							<img :src="item.icon">
						</div>
					</div>
				</div>
				<div ref="list" class="room-chat flex-grow" @scroll="scrollHandle">
					<chat-message v-for="(item, i) in messageList" :key="i" :member-type="memberDict[memberType[item.from]]" :message="item"></chat-message>
				</div>
				<chat-input ref="chatInput" @send="sendMessage"></chat-input>
			</template>
		</div>
		<div class="chat-member" :class="{'z-active': memberState}" @click.stop>
			<div class="head flex-between-center">
				<p>群成员</p>
				<a class="close tf-cross" @click="memberState = false"></a>
			</div>
			<div v-for="(item, i) in memberList" :key="i" class="item flex-center-cross">
				<div class="icon flex-center">
					<img :src="item.icon">
				</div>
				<p class="ellipsis">{{item.name}}</p>
				<div v-if="item.type" class="tag" :style="{'background': memberDict[item.type][1]}">{{memberDict[item.type][0]}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import chatMessage from './components/chat_message.vue'
	import chatInput from './components/chat_input.vue'

	const IM = window.opener.IM;
	const TencentCloudChat = window.opener.TencentCloudChat;
	
	export default {
		components: {
			chatMessage,
			chatInput
		},

		data() {
			return {
				userId: '',
				chatList: [],
				currentChat: '',
				
				memberList: [],
				memberState: false,
				paging: {},

				messageList: [],
				memberType: {},
				memberDict: {
					1: ['平台用户', '#FF6900'],
					2: ['私有商家', '#0284FF'],
					3: ['平台商家', '#0284FF'],
					4: ['爆款代理', '#00BE50'],
					5: ['专业代理', '#00BE50']
				}
			}
		},

		computed: {
			currentChatData() {
				return this.chatList.find(item => item.id == this.currentChat) || null;
			}
		},

		watch: {
			currentChat(val, old) {
				this.memberList = [];
				this.memberState = false;
				this.paging = {
					index: 1,
					size: 50,
					loading: false,
					end: false
				};
				this.messageList = [];
				this.memberType = {};
				this.$nextTick(() => {
					this.loadMessage(true);
					this.$refs.chatInput.reset();
					IM.getGroupMemberList({
						groupID: val
					}).then(({data}) => {
						this.memberList = data.memberList.map(item => {
							this.memberType[item.userID] = item.memberCustomField.find(field => field.key == 'user_type').value;
							return {
								icon: item.avatar,
								name: item.nick,
								type: this.memberType[item.userID]
							}
						});
					});
				});
				this.readCheck(old);
				this.readCheck(val);
			}
		},
		
		mounted() {
			document.title = '冠鸣平台 - 客服';

			window.addEventListener('message', ({data: {event, data}}) => {
				console.log('chat get:', event, data);
				if (event == 'close') {
					window.close();
				}
			});
			window.addEventListener('click', () => {
				this.memberState = false;
			});

			IM.getMyProfile().then(({data}) => {
				this.userId = data.userID;
			});

			!function loop() {
				IM.getConversationList().then(({data}) => {
					this.updateChatList({
						data: data.conversationList
					});
					if (!data.isSyncCompleted) {
						setTimeout(() => {
							loop.call(this);
						}, 200);
					} else {
						IM.on(TencentCloudChat.EVENT.MESSAGE_RECEIVED, this.messageReceived);
						IM.on(TencentCloudChat.EVENT.CONVERSATION_LIST_UPDATED, this.updateChatList);
					}
				});
			}.call(this);

			window.addEventListener('beforeunload', () => {
				IM.off(TencentCloudChat.EVENT.MESSAGE_RECEIVED, this.messageReceived);
				IM.off(TencentCloudChat.EVENT.CONVERSATION_LIST_UPDATED, this.updateChatList);
				this.postMessage('close');
			});
		},
		
		methods: {
			updateChatList({data: list}) {
				this.chatList = list.map(({groupProfile: data, lastMessage, unreadCount}) => {
					let message = '';
					if (lastMessage.payload.description == 'text') {
						message = lastMessage.payload.data;
					} else if (lastMessage.payload.description == 'image') {
						message = '[图片]';
					} else if (lastMessage.payload.description == 'product') {
						message = '[服务卡片]';
					} else if (lastMessage.payload.description == 'order') {
						message = '[订单卡片]';
					} else if (lastMessage.payload.description == 'refund') {
						message = '[售后单卡片]';
					}

					let type = data.groupCustomField.find(item => item.key == 'group_type').value;
					return {
						id: data.groupID,
						icon: data.groupCustomField.find(item => item.key == 'customer_icon').value,
						name: type == 2 ? data.name : data.groupCustomField.find(item => item.key == 'customer_name').value,
						describe: data.introduction,
						date: new Date(lastMessage.lastTime * 1000).format('MM-dd'),
						message,
						unread: unreadCount
					}
				});
			},
			
			postMessage(event, data) {
				window.opener.postMessage({event, data}, location.origin);
			},

			messageReceived({data}) {
				data.forEach(message => {
					if (message.to !== this.currentChat) return;
					this.insertMessage(message);
					this.messageClear();
				});
			},

			messageClear() {
				if (!this.currentChat) return;
				IM.setMessageRead({
					conversationID: `GROUP${this.currentChat}`
				});
			},
			
			loadMessage(init) {
				if (this.paging.end || this.paging.loading) return;
				
				this.paging.loading = true;
				this.request({
					url: '/tim/group_chat_history',
					data: {
						group_id: this.currentChat,
						index: this.paging.index++,
						pageSize: this.paging.size,
						create_date: this.paging.time
					},
					success: data => {
						this.paging.loading = false;
						this.paging.end = data.length < this.paging.size;
						this.messageList = data.map(item => {
							let payload = {};
							try {
								payload = JSON.parse(item.msg_body)[0].MsgContent;
							} catch(e) {}
							
							return {
								from: item.from_account,
								avatar: item.head_photo,
								nick: item.nick_name,
								time: item.msg_time_stamp,
								payload: {
									data: payload.Data,
									description: payload.Desc,
									extension: payload.Ext
								}
							}
						}).concat(this.messageList);
						
						if (init) {
							if (data.length) {
								this.paging.time = data[data.length - 1].create_date;
							}
							this.reachBottom();
							this.messageClear();
						} else {
							let oldHeight = this.$refs.list.scrollHeight;
							this.$nextTick(() => {
								this.$refs.list.scrollTop = this.$refs.list.scrollTop + this.$refs.list.scrollHeight - oldHeight;
							});
						}
					}
				});
			},

			sendMessage(type, data, params = '') {
				let message = IM.createCustomMessage({
					to: this.currentChat,
					conversationType: TencentCloudChat.TYPES.CONV_GROUP,
					payload: {
						data,
						description: type,
						extension: params
					}
				});
				IM.sendMessage(message).then(() => {
					this.insertMessage(message);
					if (type == 'text') {
						this.$refs.chatInput.message = '';
					}
				});
			},

			insertMessage(message) {
				this.messageList.push(message);
				this.reachBottom();
			},

			reachBottom() {
				this.$nextTick(() => {
					this.$refs.list.scrollTop = Math.pow(10, 10);
				})
			},

			scrollHandle() {
				if (this.$refs.list.scrollTop <= 100) {
					this.loadMessage();
				}
			},

			readCheck(id) {
				clearTimeout(this._readCheckTimer);
				id && this.request({
					url: '/tim/group/read/message',
					data: {
						group_id: id
					},
					complete: () => {
						if (this.currentChat == id) {
							this._readCheckTimer = setTimeout(() => {
								this.readCheck(id);
							}, 10000);
						}
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.chat {
		height: 100vh;

		&-list {
			position: relative;
			width: 250px;
			overflow: auto;
			background: #fff;
			box-shadow: 0 0 10px 0 rgba(0,0,0,.05);

			ul {
				li {
					gap: 10px;
					padding: 15px 8px 15px 10px;
					cursor: pointer;

					&:hover, &.z-crt {
						background: #F0F2F5;
					}

					.icon {
						width: 40px;
						height: 40px;
						border-radius: 8px;
						overflow: hidden;
						background: #fff;
					}

					.name {
						height: 20px;
						line-height: 20px;
						font-size: 13px;
					}
					
					.describe {
						line-height: 16px;
						font-size: 12px;
						color: #999;
					}

					.date {
						font-size: 12px;
						color: #aaa;
					}

					.message {
						height: 16px;
						line-height: 16px;
						font-size: 12px;
						color: #999;
					}

					.unread {
						box-sizing: border-box;
						min-width: 16px;
						padding: 0 4px;
						border-radius: 8px;
						margin-left: 12px;
						line-height: 16px;
						font-size: 12px;
						text-align: center;
						color: #fff;
						background: #FF6900;
					}
				}
			}
		}

		&-room {
			background: #F0F2F5;

			.room {
				&-head {
					gap: 12px;
					height: 50px;
					border-bottom: 1px solid #ccc;
					padding: 0 16px;

					.icon {
						width: 36px;
						height: 36px;
						border-radius: 8px;
						overflow: hidden;
						background: #fff;
					}

					.name {
						font-size: 16px;
					}

					.member {
						gap: 10px;
						cursor pointer;
					}
				}

				&-chat {
					overflow-y: scroll;
				}
			}
		}

		&-member {
			z-index: 99;
			position: fixed;
			right: 0;
			top: 0;
			bottom: 0;
			width: 300px;
			background: #fff;
			box-shadow: -5px 0 5px 0 rgba(0,0,0,.1);
			transform: translate(100%,0);
			transition: transform .3s ease;

			&.z-active {
				transform: translate(0,0);
			}

			.head {
				height: 44px;
				padding: 0 10px 0 16px;

				p {
					font-size: 16px;
					font-weight: bold;
				}

				a {
					padding: 10px;
					color: #666;
				}
			}

			.item {
				height: 60px;
				border-bottom: 1px solid #eee;
				margin: 0 16px;
				font-size: 16px;
				
				.icon {
					min-width: 40px;
					height: 40px;
					border: 1px solid #eee;
					border-radius: 8px;
					margin-right: 12px;
					overflow: hidden;
				}
				
				.tag {
					border-radius: 4px;
					padding: 0 4px;
					margin-left: 8px;
					line-height: 18px;
					font-size: 12px;
					white-space: nowrap;
					color: #fff;
				}
			}
		}
	}
</style>
